import React from 'react';
import { useParams } from 'react-router-dom';
import VehicleForm from './VehicleForm.js';

export default function EditVehicle() {
  const { id } = useParams();
  return <VehicleForm id={Number(id)} />;
}
